// Trillium grandiflorum — Ontario's provincial flower.
// Drawn as a clean 3-petal line-art outline matching the lucide-react stroke style.
export const TrilliumIcon = ({
  className = "",
  size = 16,
  strokeWidth = 1.6,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    {/* Three petals at 0°, 120°, 240° */}
    <path d="M12 12 C 7.5 11, 7.5 4, 12 2 C 16.5 4, 16.5 11, 12 12 Z" />
    <path
      d="M12 12 C 7.5 11, 7.5 4, 12 2 C 16.5 4, 16.5 11, 12 12 Z"
      transform="rotate(120 12 12)"
    />
    <path
      d="M12 12 C 7.5 11, 7.5 4, 12 2 C 16.5 4, 16.5 11, 12 12 Z"
      transform="rotate(240 12 12)"
    />
    {/* Tiny center stamen */}
    <circle cx="12" cy="12" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export default TrilliumIcon;
